module.exports = __webpack_public_path__ + "img/case71.3c6f3644.png";